export default "__VITE_ASSET__77K4cRDj__"